.vc-uvs-speaker {
    color: var(--interactive-normal);
    display: flex;
    align-items: center;
    justify-content: center;
}

.vc-uvs-clickable {
    cursor: pointer;
}

.vc-uvs-clickable:hover {
    color: var(--interactive-hover);
}

.vc-uvs-profile-speaker {
    width: var(--custom-nickname-icon-size);
    height: var(--custom-nickname-icon-size);
}

.vc-uvs-tooltip-container {
    max-width: 300px;
}

.vc-uvs-tooltip-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.vc-uvs-name {
    display: flex;
    align-items: center;
    gap: 8px;
}

.vc-uvs-guild-icon {
    border-radius: 100%;
    align-self: center;
}

.vc-uvs-vc-members {
    display: flex;
    gap: 6px;
}
